<template>
  <div class="page-layout">
    <AppSidebar />

    <main class="content">
      <slot />
      <AppFooter />
    </main>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import AppSidebar from '@/components/layout/AppSidebar.vue';
import AppFooter from '@/components/layout/AppFooter.vue';

const route = useRoute();

watch(
  () => route.path,
  () => {
    document.querySelector<HTMLElement>('.content')?.scrollTo({ top: 0 });
  },
);
</script>
